import classNames from 'classnames';
import { ReactSVG } from 'react-svg';
import { Button } from '@forma/forma-ui-kit';
import PageBlock from '@/components/PageBlock';
import Link from '@/components/Link';

import styles from './buttons-block.module.css';

const ButtonsBlock = ({ title, items, className }) => {
  return (
    <PageBlock className={classNames(styles.root, className)} title={title}>
      <div className={styles.container}>
        <div className={styles.items}>
          {items.map(({ name, href, icon }) => (
            <Button
              as={Link}
              viewStyle="secondary"
              className={classNames(styles.button, styles.secondary)}
              // onClick={() => {
              //   analytics.clickTryTrial();
              // }}
              href={href}
              target="_blank"
              icon={<ReactSVG src={icon} wrapper="span" />}
              key={name}
            >
              {name}
            </Button>
          ))}
        </div>
      </div>
    </PageBlock>
  );
};

export default ButtonsBlock;
